import { FontImage, ImageSection, Name, TypographySection } from '../styles'
import {
    LineHeight15,
    LineHeight24Position,
} from 'src/components/common/Typography/typography'
import React from 'react'
import { MeetLabels } from 'src/types'

export function TeamContent(props: MeetLabels) {
    const { image, WorkField, name, textCity } = props

    return (
        <>
            <FontImage>
                <ImageSection src={image} alt={name} loading="lazy" />
            </FontImage>
            <TypographySection>
                <LineHeight24Position
                    variant={'h3'}
                    fontSize={'xsmall'}
                    fontWeight={500}
                >
                    {WorkField}
                </LineHeight24Position>
                <Name variant={'h2'} fontSize={'xxxsmall'} fontWeight={700}>
                    {name}
                </Name>

                <LineHeight15
                    variant={'h3'}
                    fontSize={'xsmall'}
                    fontWeight={400}
                >
                    {textCity}
                </LineHeight15>
            </TypographySection>
        </>
    )
}
